import { render, staticRenderFns } from "./order-item-header.vue?vue&type=template&id=61afd39c&scoped=true"
import script from "./order-item-header.vue?vue&type=script&lang=js"
export * from "./order-item-header.vue?vue&type=script&lang=js"
import style0 from "./order-item-header.vue?vue&type=style&index=0&id=61afd39c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61afd39c",
  null
  
)

export default component.exports